enum EnvTypes {
  DEMO = 'DEMO',
  production = 'production',
  STAGE = 'STAGE',
  QA_01 = 'QA_01',
  DEV_NEXT = 'DEV_NEXT'
}

interface Configuration {
  HITT_URL: Location | string;
  WDT_WB_URL: Location | string;
  ASSET_URL: Location | string;
}

interface TConfig {
  DEMO: Configuration;
  production: Configuration;
  STAGE: Configuration;
  QA_01: Configuration;
  DEV_NEXT: Configuration;
}

export const ENVIRONMENT_CONFIGS: TConfig = {
  [EnvTypes.DEMO]: {
    HITT_URL: 'https://demo-idtt.lwtears.com',
    WDT_WB_URL: 'https://production-whiteboard.lwtears.com/#/',
    ASSET_URL: 'https://dtt-content.s3.amazonaws.com'
  },
  [EnvTypes.production]: {
    HITT_URL: 'https://hitt.lwtears.com/login',
    WDT_WB_URL: 'https://production-whiteboard.lwtears.com/#/',
    ASSET_URL: 'https://dtt-content.s3.amazonaws.com'
  },
  [EnvTypes.STAGE]: {
    HITT_URL: 'https://stage-hitt.lwtears.com/login',
    WDT_WB_URL: 'https://stage-whiteboard.lwtears.com/#/',
    ASSET_URL: 'https://dtt-content.s3.amazonaws.com'
  },
  [EnvTypes.QA_01]: {
    HITT_URL: 'https://qa01-hitt.lwtears.com/login',
    WDT_WB_URL: 'https://qa02-whiteboard.lwtears.com/#/',
    ASSET_URL: 'https://dtt-content.s3.amazonaws.com'
  },
  [EnvTypes.DEV_NEXT]: {
    HITT_URL: 'https://dev-next-hitt.lwtears.com/login',
    WDT_WB_URL: 'https://dev-next-whiteboard.lwtears.com/#/',
    ASSET_URL: 'https://dtt-content.s3.amazonaws.com'
  }
};

const getConfig = (env: EnvTypes): Configuration => {
  return ENVIRONMENT_CONFIGS[env];
};

export default getConfig(process.env.REACT_APP_BUILD_ENV as EnvTypes);
